import ApiServer from "../ApiServer.ts";
import { format } from "../lib/DateUtils.ts";
import {SyncCache} from "../lib/SyncCache.ts";
import { birthDateBean } from "../server/decoders_connected.ts";
import Icons, { SvgFile } from "../svg/Icons.ts";

export const ContactCache = new SyncCache<ApiServer.types.ContactBean>(
  ApiServer.ctcsync,
  function(a,b){return a.displayName.localeCompare(b.displayName)
})

Object.assign(ApiServer.types.IContact.prototype,{
  onDecode(json){
    this.birthDateBean = birthDateBean
    this.displayName = ((this.firstName||"")+" "+(this.lastName||"")).trim();
    this.hasDetail = this.devices.length||this.addresses.length ||this.birthDate!==undefined
  }
 });

 Object.assign(ApiServer.types.IDevice.prototype,{
  onDecode(){
    this.label = {
      MOBILE:'labels.mobile',
      EMAIL:'labels.email'
      }[this.deviceType]||'labels.phone'
    this.placeholder = {
      EMAIL:'johndoe@email.com'
      }[this.deviceType]||'(902) 930-3589'

    this.icon = {
      MOBILE:Icons.contact.ic_contact_mobile_phone,
      EMAIL:Icons.ic_email
      }[this.deviceType]||Icons.contact.ic_contact_phone

  }
 });

 Object.assign(ApiServer.types.IAddress.prototype,{
  onDecode(){
    this.label = {
      WORK:'addressType.WORK'
      }[this.placeType]||'addressType.HOME'
    this.icon = {
      WORK:  Icons.contact.ic_contact_work_address
      }[this.placeType]||Icons.ic_location

    this.placeholder = 'modalplace.placeholder_address'

  }
 });